module.exports = window.T['views/changes.html'] || "<div class=\"container\"><div class=\"row\"><changelist changes=\"changes\"></changelist></div></div>";